module.exports = __webpack_public_path__ + "images/admin/vc/14_34.gif";


//////////////////
// WEBPACK FOOTER
// ./images/admin/vc/14_34.gif
// module id = 44
// module chunks = 0